import { SetStateAction, useEffect, useState } from 'react'
import { TitleH1 } from '../../../../Components/CustomUi/titleH1'
import ViewPage from '../../../../Components/ViewPage'
import { TabelaOs } from './components/tabela'
import { ContainerOs } from './styled'
import { useLogic } from '../../../../context/useLogic'
import { useHistory } from 'react-router'
import { getSafraConsultoria, SafraItens } from '../../../../services/Safra'
import { delPedLaboratorio, getPedLaboratorio } from '../../../../services/Laboratorio'
import { getPropriedade } from '../../../../services/Propriedades'
import { getTalhao, getTalhaoPorSafra } from '../../../../services/Talhao'
import { useGetOsColetada, useGetOsColetadaEditar } from '../../../../services/OsParaColeta/GET'
import { FormularioOsColeta } from './components/formulario'
import dayjs from 'dayjs'
import { PreencherDados, converteKmlBase64 } from './components/meta'
import { getFornecedor } from '../../../../services/Fornecedores'
import { localConfig } from '../../../../Configs/localConfig'
import { LabAnaliseItens } from '../../../../services/LabAnalise'
import { GeoPointFeature } from './components/formulario/components/análises/components/headerAnalises/components/modalNovaAnalise'
import { ClienteItensTypes, getCliente } from '../../../../services/Cliente'
import { EquipeItens } from '../../../../services/Equipe'
import { usePostOsParaColeta, usePutOsParaColeta } from '../../../../services/OsParaColeta/POST'
import {
  getRepresentanteLegal,
  RepresentanteLegalItens,
} from '../../../../services/RepresentanteLegal'
import { errorAlert, successAlert } from '../../../../utils/alert'
import { Modal } from 'antd'
import { Warning } from '../../../../Components/CustomUi/warning'
import { FooterModalLab } from '../../../../Components/ordemLaboratorio/styled'
import ButtonCustom from '../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleRight, faXmark } from '@fortawesome/free-solid-svg-icons'
import { ItensPerUserLogged } from '../../../../services/login/permissaoUsuarioLoado'
import { useGetEquipeCliente } from '../../../../services/Equipe/GET'
import { tiposGerais, tiposSistema, tiposSistemaGeral } from '../../../../services/Afins'


export type PropsAnalisesCadastradas = {
  id?: string | number
  cod_analise: number
  cor: string
  pontos_selecionados: GeoPointFeature[]
  profundidade: string
  analise_nome: string
  valor: string
  valor_analise: string
}

export type PropsTiposAnalise = {
  cod: number
  nome: string
  cod_tipo_geral: number
  ordem: number
  tipo_geral_nome: string
}

const OsParaColeta: React.FC = () => {
  const { checkSafra } = useLogic()
  const history = useHistory()
  const codSafra = localStorage.getItem('codSafra')

  //TABELA
  const [permissions, setPermissions] = useState<ItensPerUserLogged>()
  const [tab_selecionar_atual, setTab_selecionar_atual] = useState<
    | 'Solo'
    | 'Plantas'
    | 'Folhas'
    | 'Raízes'
    | 'Microbiológica'
    | 'Fertilizantes'
    | 'Corretivos'
    | 'Composto orgânico'
    | 'Outro'
  >('Solo')
  const [dataSafraConsultoria, setDataSafraConsultoria] = useState([])
  const [dataOrderSer, setDataOrderSer] = useState([])
  const [dataOrderSerOld, setDataOrderSerOld] = useState([])
  const [loadingTable, setLoadingTable] = useState(false)
  const [buscar_tabela, setBuscar_tabela] = useState<string>('')
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [total, setTotal] = useState<number>(0)
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)
  const [propriedade_selecionada, setPropriedade_selecionada] = useState<string>('')
  const [propriedade_selecionada_id, setPropriedade_selecionada_id] = useState<number>(null)
  const [talhao_selecionado, setTalhao_selecionado] = useState<string>('')
  const [talhao_selecionado_id, setTalhao_selecionado_id] = useState<number>(null)
  const [listPropriedade, setListPropriedade] = useState([])
  const [listTalhoes, setListTalhoes] = useState([])
  const [tipos_analises, setTipos_analises] = useState<PropsTiposAnalise[]>([])

  //FORMULARIO
  const [abrirGaveta, setAbrirGaveta] = useState<boolean>(false)
  const [update, setUpdate] = useState<number>(null)
  const [copiar, setCopiar] = useState<number>(null)
  const [dados_cliente, setDados_clientes] = useState<ClienteItensTypes>({})
  const [status_atual, setStatus_atual] = useState<string>('')
  const [status_atual_id, setStatus_atual_id] = useState<number>(null)
  const [data_da_os, setData_da_os] = useState<string>('')
  const [outros_solicitantes, setOutros_solicitantes] = useState<string>('')
  const [propriedade, setPropriedade] = useState<string>('')
  const [propriedade_id, setPropriedade_id] = useState<number>(null)
  const [talhao, setTalhao] = useState<string>('')
  const [talhao_id, setTalhao_id] = useState<number>(null)
  const [matricula, setMatricula] = useState<string>('')
  const [area_propriedade, setArea_propriedade] = useState<string>('')
  const [laboratorio, setLaboratorio] = useState<string>('')
  const [laboratorio_id, setLaboratorio_id] = useState<number>(null)
  const [safra_consultoria, setSafra_consultoria] = useState<string>('')
  const [safra_consultoria_id, setSafra_consultoria_id] = useState<number>(null)
  const [area_amostra_laudo, setArea_amostra_laudo] = useState<'50 ha' | '20 ha'>('50 ha')
  const [tipo_de_analise, setTipo_de_analise] = useState<string>('')
  const [responsaveis_selecionados, setResponsaveis_selecionados] = useState<
    { descr: string; id: number; key?: number }[]
  >([])
  const [coleta_liberada, setColeta_liberada] = useState<string>('')
  const [coletado_em, setColetado_em] = useState<string>('')
  const [representante_selecionado, setRepresentante_selecionado] = useState<string>('')
  const [representante_selecionado_id, setRepresentante_selecionado_id] = useState<number>(null)
  const [open_loading_analise_lab, setOpen_loading_analise_lab] = useState<boolean>(false)
  const [grupoAnalises, setGrupoAnalises] = useState<LabAnaliseItens[]>([])
  const [data_laboratorio, setData_laboratorio] = useState([])
  const [data_safra_consultoria, setData_safra_consultoria] = useState<SafraItens[]>([])
  const [data_equipe, setData_equipe] = useState<EquipeItens[]>([])
  const [data_representante, setData_representante] = useState<RepresentanteLegalItens[]>([])
  const [analises_nao_encontradas, setAnalises_nao_encontradas] = useState([])
  const [open_modal_confirm_lab, setOpen_modal_confirm_lab] = useState<boolean>(false)
  const [valores_analises_editados, setValores_analises_editados] = useState([])
  const [fake_loading_descartar, setFake_loading_descartar] = useState<boolean>(false)

  //ANALISES
  const [malha, setMalha] = useState<any>([])
  const [malhaShp, setMalhaShp] = useState<any>([])
  const [tipo_analise_selecionada, setTipo_analise_selecionada] = useState<string>('')
  const [tipo_analise_selecionada_id, setTipo_analise_selecionada_id] = useState<number>(null)
  const [loadingShape, setLoadingShape] = useState<boolean>(false)
  const [pontos_selecionados, setPontos_selecionados] = useState<GeoPointFeature[]>([])
  const [pontos_selecionados_adicionados, setPontos_selecionados_adicionados] = useState<
    PropsAnalisesCadastradas[]
  >([])
  const [pontosTotalMalha, setPontosTotalMalha] = useState<number>(0)
  const [analises, setAnalises] = useState([])
  const [talhaoKml, setTalhaoKml] = useState([])
  const [talhaoArea, setTalhaoArea] = useState<string>('')

  //API
  const { carregando_osColeta, data_osColeta, refetch_data_osColeta } = useGetOsColetada(
    pagination,
    page,
    buscar_tabela,
    localConfig?.().codSafra,
    propriedade_selecionada_id
  )
  const { carregando_osColeta_editar, data_osColeta_editar, refetch_data_osColeta_editar } =
    useGetOsColetadaEditar(update ?? copiar)

  const { carregando_salvar_os, mutate_os } = usePostOsParaColeta()
  const { carregando_editar_os, mutate_editar_os } = usePutOsParaColeta(update)
  const { data_equipe_cliente } = useGetEquipeCliente();

  const Propriedades = async () => {
    const resp = await getPropriedade('')

    setListPropriedade(resp.data.itens)
  }

  const listarSafraConsultoria = async () => {
    const response = await getSafraConsultoria()
    setData_safra_consultoria(response.data.itens)
  }

  const listaLaboratorio = async () => {
    const resp = await getFornecedor({ codConta: localConfig()?.conta, codCategoria: 2 })

    setData_laboratorio(resp.data.itens)
  }

  async function listarTipos() {
    const resp = await tiposSistema(281)
    setTipos_analises(resp)
  }

  const Talhoes = async (cod) => {
    const resp = await getTalhao(cod, '')
    const teste = resp?.data?.itens.map((item) => {
      return {
        ...item,
        coordenadas: item?.kml?.coordenadas,
      }
    })
    setListTalhoes(teste)
  }

  const cliente = async () => {
    const config = localConfig()
    if (config.codCliente !== '') {
      const resp = await getCliente(config.codCliente, '', '', '')
      const dados = resp.data.itens[0]

      if (dados.tipo === 'G') {
        const response = await getRepresentanteLegal('', config.codCliente)
        const repre = response.data.itens

        setData_representante(repre)
      } else {
        setOutros_solicitantes(dados.solicitante)
      }
      setDados_clientes(dados)
    }
  }

  const listarOrdensServico = async () => {
    const safras = await getSafraConsultoria()
    setDataSafraConsultoria(safras.data.itens)
    setTotal(data_osColeta?.total)
    setLoadingTable(false)
  }

  function buscarTalhaoPropriedade(cod) {
    const filterPropriedade = listPropriedade
      ?.filter((item) => item?.status === 1)
      .filter((rec) => rec?.cod === cod)
    cliente()
    setPropriedade(filterPropriedade[0]?.nome)
    setPropriedade_id(cod)
    setMatricula(filterPropriedade[0]?.matricula)
    setArea_propriedade(filterPropriedade[0]?.area)
    Talhoes(cod)
  }

  function abrirGavetaOs() {
    setAbrirGaveta(true)
  }

  function fecharGaveta() {
    setUpdate(null)
    setCopiar(null)
    setAbrirGaveta(false)
    setData_da_os('')
    setPropriedade('')
    setPropriedade_id(null)
    setTalhao('')
    setTalhao_id(null)
    setLaboratorio('')
    setLaboratorio_id(null)
    setSafra_consultoria('')
    setSafra_consultoria_id(null)
    setArea_amostra_laudo('50 ha')
    setResponsaveis_selecionados([])
    setRepresentante_selecionado('')
    setRepresentante_selecionado_id(null)
    setColeta_liberada('')
    setColetado_em('')
    setPontos_selecionados([])
    setPontos_selecionados_adicionados([])
    setAnalises([])
    setMalha([])
    setMalhaShp([])
    setPontosTotalMalha(0)
  }

  function editarOs(cod) {
    setUpdate(cod)
    setAbrirGaveta(true)
  }
  function copiarOs(cod) {
    setCopiar(cod)
    setAbrirGaveta(true)
  }

  async function excluirOs(cod) {
    setFake_loading(true)
    try {
      const responseDel = await delPedLaboratorio(cod)

      if (responseDel.status === 200) {
        successAlert('Pedido de analise excluido com sucesso!')

        refetch_data_osColeta()
        setFake_loading(false)
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response

        errorAlert(data?.error ?? 'Falha na operação')
        setFake_loading(false)
      }
    }
    setTimeout(() => {
      setFake_loading(false)
    }, 500)
  }

  function salvarOsColeta() {
    const analisesTratadas = analises?.map((item) => {
      return {
        title: item?.analise_nome,
        cod_analises: {
          cod: item?.cod_analise,
          valor: item?.valor,
        },
        id: item?.id,
        pontos: item?.pontos_selecionados?.map((item) => {
          return {
            NOME: item?.NOME,
            INDICE: item?.INDICE,
            COMENTARIO: '',
            LATITUDE: item?.LATITUDE,
            LONGITUDE: item?.LONGITUDE,
          }
        }),
        valor_analise: item?.valor_analise,
      }
    })

    const cod_tipo = tipos_analises?.find((item) =>
      item?.nome?.toLowerCase()?.includes(tipo_de_analise?.toLowerCase())
    )?.cod

    const total = analisesTratadas.reduce((acc, item) => {
      const valor = parseFloat(
        item.valor_analise
          .replace(/\./g, '') // remove milhar
          .replace(',', '.') // vírgula -> ponto
          .replace(/[^\d.]/g, '') // tira R$ e espaços estranhos
      )

      return acc + valor
    }, 0)

    if (update <= 0 || copiar > 0) {
      mutate_os({
        data: !data_da_os ? dayjs(new Date()).format('DD/MM/YYYY') : dayjs(data_da_os).format('DD/MM/YYYY'),
        status: 1,
        cod_laboratorio: laboratorio_id,
        cod_propriedade: propriedade_id,
        cod_talhao: talhao_id,
        cod_responsaveis: responsaveis_selecionados?.map((item) => item?.id),
        cod_tipo: cod_tipo,
        solicitante: outros_solicitantes,
        cod_area_amostra: parseFloat(area_amostra_laudo),
        cod_safra_conta: safra_consultoria_id,
        malha_de_pontos: malhaShp,
        data_liberada: dayjs(coleta_liberada).format('DD/MM/YYYY'),
        data_coleta: dayjs(coletado_em).format('DD/MM/YYYY'),
        analises: analisesTratadas,
        valor: total,
        refetch: () => { refetch_data_osColeta(); fecharGaveta() },
      })
    } else {
      mutate_editar_os({
        data: !data_da_os ? dayjs(new Date()).format('DD/MM/YYYY') : dayjs(data_da_os).format('DD/MM/YYYY'),
        status: status_atual_id,
        cod_laboratorio: laboratorio_id,
        cod_propriedade: propriedade_id,
        arquivo_kml: converteKmlBase64(talhaoKml),
        cod_responsaveis: responsaveis_selecionados?.map((item) => item?.id),
        cod_tipo: cod_tipo,
        solicitante: outros_solicitantes,
        cod_area_amostra: parseFloat(area_amostra_laudo),
        cod_safra_conta: safra_consultoria_id,
        malha_de_pontos: malhaShp,
        data_liberada: dayjs(coleta_liberada).format('DD/MM/YYYY'),
        data_coleta: dayjs(coletado_em).format('DD/MM/YYYY'),
        analises: analisesTratadas,
        valor: total,
        refetch: () => { refetch_data_osColeta(); fecharGaveta() },
      })
    }
  }

  function cancelarAlteracaoDeLab() {
    setOpen_modal_confirm_lab(false)
    setAnalises_nao_encontradas([])
    setValores_analises_editados([])
  }

  function descartarEProsseguir() {
    setFake_loading_descartar(true)
    setGrupoAnalises(valores_analises_editados)
    setTimeout(() => {
      setFake_loading_descartar(false)
      setOpen_modal_confirm_lab(false)
      setAnalises_nao_encontradas([])
      setValores_analises_editados([])
    }, 1000)
  }

  useEffect(() => {
    if (data_osColeta_editar) {
      PreencherDados({
        data_osColeta_editar,
        listTalhoes,
        setArea_amostra_laudo,
        setColeta_liberada,
        setColetado_em,
        setData_da_os,
        setLaboratorio,
        setLaboratorio_id,
        setOutros_solicitantes,
        setPropriedade,
        setPropriedade_id,
        setResponsaveis_selecionados,
        setSafra_consultoria,
        setSafra_consultoria_id,
        setStatus_atual,
        setStatus_atual_id,
        setTalhao,
        setTalhao_id,
        setOpen_loading_analise_lab,
        setGrupoAnalises,
        setAnalises,
        setMalha,
        setMalhaShp,
        setPontosTotalMalha,
        setTalhaoKml
      })
    }
  }, [data_osColeta_editar])

  useEffect(() => {
    if (update > 0 || copiar > 0) {
      refetch_data_osColeta_editar()
    }
  }, [update, copiar])

  useEffect(() => {
    if (talhao_selecionado !== '') {
      const filterTalhao = listTalhoes?.filter((item) => item?.cod === talhao_selecionado_id)
      const filter = dataOrderSerOld?.filter((item) => item?.talhao_nome === talhao_selecionado)

      setTalhao(filterTalhao[0]?.nome)
      setTalhao_id(filterTalhao[0]?.cod)
      setTalhaoKml(filterTalhao)
      setDataOrderSer(filter)
    } else {
      setDataOrderSer(dataOrderSerOld)
    }
  }, [talhao_selecionado])

  useEffect(() => {
    if (talhao !== '') {
      const filterTalhao = listTalhoes?.filter((item) => item?.cod === talhao_id)
      setTalhaoKml(
        filterTalhao[0]?.coordenadas.map((coord: any) => ({
          lng: Number(coord?.longitude),
          lat: Number(coord?.latitude),
        }))
      )
    }
  }, [talhao_id])

  useEffect(() => {
    if (data_osColeta?.itens) {
      setDataOrderSer(data_osColeta?.itens)
      setDataOrderSerOld(data_osColeta?.itens)
    }
  }, [data_osColeta])

  useEffect(() => {
    if (propriedade_selecionada_id) {
      refetch_data_osColeta()
    }
  }, [pagination, page])

  useEffect(() => {
    if (codSafra !== null) {
      Propriedades()
    }
  }, [codSafra])

  useEffect(() => {
    if (propriedade_selecionada_id) {
      refetch_data_osColeta()
      buscarTalhaoPropriedade(propriedade_selecionada_id)
    }
  }, [propriedade_selecionada_id])

  useEffect(() => {
    if (tab_selecionar_atual) {
      const filterTipo = tipos_analises?.filter((item) =>
        item?.nome?.toLowerCase()?.includes(tab_selecionar_atual?.toLowerCase())
      )
      setTipo_de_analise(filterTipo[0]?.nome)
    }
  }, [tab_selecionar_atual])

  useEffect(() => {
    listarOrdensServico()
    listaLaboratorio()
    listarSafraConsultoria()
    listarTipos()
  }, [])

  useEffect(() => {
    const idDaSafra = checkSafra('/precisao/laborder')
    console.log('idDaSafra', idDaSafra)
    if (!idDaSafra) {
      history.push('/home')
    }
  }, [])

  return (
    <ContainerOs>
      <ViewPage
        onPermission={setPermissions}
        title='Os para coleta'
        rotina={32}
        hiddeTitle
        cardBodyStyle={{ padding: 15 }}
        cardMainStyle={{ height: '87.5vh' }}
        newHide
      >
        <div style={{ marginBottom: '10px' }}>
          <TitleH1>Os para coleta</TitleH1>
        </div>

        <TabelaOs
          loading={carregando_osColeta}
          list_os={dataOrderSer}
          permissions={permissions}
          dataSafraConsultoria={dataSafraConsultoria}
          deletar={excluirOs}
          abrir={abrirGavetaOs}
          editar={editarOs}
          copiar={copiarOs}
          buscar_tabela={buscar_tabela}
          setBuscar_tabela={setBuscar_tabela}
          tab_selecionar_atual={tab_selecionar_atual}
          setTab_selecionar_atual={setTab_selecionar_atual}
          page={page}
          setPage={setPage}
          setPagination={setPagination}
          total={total}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          nome_item_atual={nome_item_atual}
          setNome_item_atual={setNome_item_atual}
          fake_loading={fake_loading}
          setFake_loading={setFake_loading}
          propriedade_selecionada={propriedade_selecionada}
          setPropriedade_selecionada={setPropriedade_selecionada}
          setPropriedade_selecionada_id={setPropriedade_selecionada_id}
          talhao_selecionado={talhao_selecionado}
          setTalhao_selecionado={setTalhao_selecionado}
          setTalhao_selecionado_id={setTalhao_selecionado_id}
          tipo_de_analise={tipos_analises?.find((item) =>
            item?.nome?.toLowerCase()?.includes(tab_selecionar_atual?.toLowerCase())
          )?.cod}
          listPropriedade={listPropriedade?.filter((item) => item?.status === 1)}
          listTalhoes={listTalhoes}
          refetch={refetch_data_osColeta}
        />

        <FormularioOsColeta
          abrirGaveta={abrirGaveta}
          fecharGaveta={fecharGaveta}
          update={update}
          permissions={permissions}
          salvarOsColeta={salvarOsColeta}
          loadingSalvarOsColeta={carregando_salvar_os || carregando_editar_os}
          loading_formulario={carregando_osColeta_editar}
          dados_cliente={dados_cliente}
          data_representante={data_representante}
          status_atual={status_atual}
          setStatus_atual={setStatus_atual}
          setStatus_atual_id={setStatus_atual_id}
          data_da_os={data_da_os}
          setData_da_os={setData_da_os}
          outros_solicitantes={outros_solicitantes}
          setOutros_solicitantes={setOutros_solicitantes}
          propriedade={propriedade}
          setPropriedade={setPropriedade}
          setPropriedade_id={setPropriedade_id}
          talhao={talhao}
          setTalhao={setTalhao}
          setTalhao_id={setTalhao_id}
          matricula={matricula}
          area_propriedade={area_propriedade}
          laboratorio={laboratorio}
          setLaboratorio={setLaboratorio}
          setLaboratorio_id={setLaboratorio_id}
          safra_consultoria={safra_consultoria}
          setSafra_consultoria={setSafra_consultoria}
          setSafra_consultoria_id={setSafra_consultoria_id}
          area_amostra_laudo={area_amostra_laudo}
          setArea_amostra_laudo={setArea_amostra_laudo}
          responsaveis_selecionados={responsaveis_selecionados}
          setResponsaveis_selecionados={setResponsaveis_selecionados}
          coleta_liberada={coleta_liberada}
          setColeta_liberada={setColeta_liberada}
          coletada_em={coletado_em}
          setColetada_em={setColetado_em}
          representante_selecionado={representante_selecionado}
          setRepresentante_selecionado={setRepresentante_selecionado}
          setRepresentante_selecionado_id={setRepresentante_selecionado_id}
          grupoAnalises={grupoAnalises}
          setGrupoAnalises={setGrupoAnalises}
          tipo_de_analise={tipo_de_analise}
          setTipo_de_analise={setTipo_de_analise}
          open_loading_analise_lab={open_loading_analise_lab}
          setOpen_loading_analise_lab={setOpen_loading_analise_lab}
          setAnalises_nao_encontradas={setAnalises_nao_encontradas}
          setOpen_modal_confirm_lab={setOpen_modal_confirm_lab}
          setValores_analises_editados={setValores_analises_editados}
          dataPropriedades={listPropriedade?.filter((item) => item?.status === 1)}
          dataTalhoes={listTalhoes}
          data_laboratorio={data_laboratorio}
          data_safra_consultoria={data_safra_consultoria}
          data_equipe={data_equipe_cliente}
          data_tipos_analise={tipos_analises}
          buscarTalhaoPropriedade={buscarTalhaoPropriedade}
          propriedade_id={propriedade_id}
          talhao_id={talhao_id}
          laboratorio_id={laboratorio_id}
          data_osColeta_editar={data_osColeta_editar}
          setLoadingShape={setLoadingShape}
          malha={malha}
          setMalha={setMalha}
          malhaShp={malhaShp}
          setMalhaShp={setMalhaShp}
          tipo_analise_selecionada={tipo_analise_selecionada}
          setTipo_analise_selecionada={setTipo_analise_selecionada}
          tipo_analise_selecionada_id={tipo_analise_selecionada_id}
          setTipo_analise_selecionada_id={setTipo_analise_selecionada_id}
          pontos_selecionados={pontos_selecionados}
          setPontos_selecionados={setPontos_selecionados}
          pontos_selecionados_adicionados={pontos_selecionados_adicionados}
          setPontos_selecionados_adicionados={setPontos_selecionados_adicionados}
          analises={analises}
          setAnalises={setAnalises}
          pontosTotalMalha={pontosTotalMalha}
          setPontosTotalMalha={setPontosTotalMalha}
          talhaoKml={talhaoKml}
          setTalhaoKml={setTalhaoKml}
          talhaoArea={talhaoArea}
          setTalhaoArea={setTalhaoArea}
        />

        <Modal
          open={open_modal_confirm_lab}
          onCancel={() => cancelarAlteracaoDeLab()}
          title='Análises não encontradas'
          width={700}
          footer={false}
          zIndex={99999}
        >
          As análises listadas abaixo não foram encontradas no cadastro do laboratório informado.{' '}
          <b>Deseja descartá-las e prosseguir apenas com as análises cadastradas?</b>
          {(analises_nao_encontradas ?? []).map((item, index) => {
            return (
              <Warning type='error' style={{ margin: '5px 0px' }} key={item?.id + index}>
                {item?.cod_analises?.[0]?.nome} ({item?.profundidade})
              </Warning>
            )
          })}
          <FooterModalLab>
            <ButtonCustom
              onClick={() => {
                cancelarAlteracaoDeLab()
              }}
              type='secondary'
              danger
              icon={<FontAwesomeIcon icon={faXmark} />}
            >
              Cancelar
            </ButtonCustom>
            <ButtonCustom
              onClick={() => {
                descartarEProsseguir()
              }}
              type='primary'
              icon={<FontAwesomeIcon icon={faArrowCircleRight} />}
              loading={fake_loading_descartar}
            >
              Descartar e prosseguir
            </ButtonCustom>
          </FooterModalLab>
        </Modal>
      </ViewPage>
    </ContainerOs>
  )
}

export default OsParaColeta
